import { displayPrice } from 'common/utilities/utils';

export const displayTipAmount = (tipCharge, currencySymbol, currencyConversionFactor) => {
  return tipCharge !== 0 ? displayPrice(tipCharge, { currencySymbol, currencyConversionFactor }) : 0;
};
